import type { I18nLocale } from '@ardoq/i18n';
import type { SpiderViewSettings } from '@ardoq/xyz-charts';
import type { NumericField } from 'tabview/chartShared/types';

/** What the view publishes for the settings bar to read. */
export type SpiderViewProperties = {
  viewSettings: SpiderViewSettings;
  numericFields: NumericField[];
  i18nLocale: I18nLocale;
  isEmptyView: boolean;
  viewInstanceId: string;
};

const SPIDER_VIEW_PROPERTIES_KEYS = [
  'viewSettings',
  'numericFields',
  'i18nLocale',
  'isEmptyView',
  'viewInstanceId',
] as const satisfies readonly (keyof SpiderViewProperties)[];

export const isSpiderViewProperties = (
  viewProperties: Record<string, unknown>
): viewProperties is SpiderViewProperties =>
  SPIDER_VIEW_PROPERTIES_KEYS.every(key => viewProperties[key] !== undefined);
